<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part main_top_search">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="tempeoraryManName" :placeholder="$t('message.tempeoraryNameTitle')"></el-input>
        </div>
        <div class="search_item">
          <el-date-picker
            v-model="attendanceTime"
            type="datetimerange"
            range-separator=" - "
            :start-placeholder="$t('message.attendanceTimeTitle') + $t('message.orderTimeStartHolder')"
            :end-placeholder="$t('message.attendanceTimeTitle') + $t('message.orderTimeEndHolder')"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </div>
        <div class="search_item">
          <el-select v-model="ISExternalDRIVER" style="margin-right: 10px;">
            <el-option label="全部" value></el-option>
            <el-option label="外部司机" value="1"></el-option>
            <el-option label="不是外部司机" value="0"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-select v-model="STATE1" style="margin-right: 10px;">
            <!-- <el-option label="全部" value=" "></el-option> -->
            <el-option :label="$t('message.isJob')" value=" "></el-option>
            <el-option :label="$t('message.isQuit')" value="离职"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-select v-model="ISDRIVER" style="margin-right: 10px;">
            <el-option label="全部" value></el-option>
            <el-option :label="$t('message.SiJiTitle')" value="1"></el-option>
            <el-option :label="$t('message.NoSiJiTitle')" value="0"></el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-select v-model="YINGYESUO1" style="margin-right: 10px;">
            <el-option label="全部" value></el-option>
            <el-option label="大阪営業所" value="大阪営業所"></el-option>
            <el-option label="りんくう営業所" value="りんくう営業所"></el-option>
            <el-option label="東京営業所" value="東京営業所"></el-option>
            <el-option label="関空営業所" value="関空営業所"></el-option>
            <el-option label="泉佐野営業所" value="泉佐野営業所"></el-option>
            <el-option label="市川営業所" value="市川営業所"></el-option>
            <el-option label="大田営業所" value="大田営業所"></el-option>
            <el-option label="藤井寺営業所" value="藤井寺営業所"></el-option>
            <el-option label="成田営業所" value="成田営業所"></el-option>
          </el-select>
        </div>
        <span class="search_btn" @click="searchTempeoraryName">{{$t('message.searchBtnText')}}</span>

        <div class="search_item">
          <span class="search_title">{{$t('message.todayClockNum')}}: {{todayFormal}}</span>
        </div>
        <div class="add_btn" @click="addNewTempeorary">
          <img class="add_icon" src="@/assets/addIcon.svg" />
          {{$t('message.addformalWorkersTitle')}}
        </div>
        <div
          class="add_btn"
          style="margin-left: 10px;"
          @click="exportMoreFormal"
        >{{$t('message.exportText')}}</div>
      </div>
      <!-- <div class="search_box"></div> -->
    </div>
    <!-- 搜索栏 -->
    <div class="content">
      <div class="tableBox">
        <el-table
          id="tempeoraryMenList"
          :data="tempeoraryMenList"
          style="width: 100%"
          stripe
          size="small"
          header-cell-class-name="tableHeader"
          cell-class-name="tableBodyer"
          height="100%"
          v-loading="loading"
        >
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
          <el-table-column
            :label="$t('message.tempeoraryNameTitle')"
            prop="USHOWNAME"
            min-width="120"
          ></el-table-column>
          <el-table-column
            :label="$t('message.tempeoraryPhoneTitle')"
            prop="TELPHONE"
            min-width="120"
          ></el-table-column>
          <el-table-column :label="$t('message.tempeoraryEmailTitle')" prop="EMAIL" min-width="150"></el-table-column>
          <el-table-column
            :label="$t('message.tempeoraryAccountTitle')"
            prop="UINPUTNAME"
            min-width="120"
          ></el-table-column>
          <el-table-column :label="$t('message.BusinessOffice')" prop="YINGYESUO" min-width="120"></el-table-column>
          <el-table-column :label="$t('message.signatureStateTitle')" prop="STATE" min-width="120">
            <template slot-scope="scope">
              <span>{{scope.row.STATE=='离职'?$t('message.isQuit'):$t('message.isJob')}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.IsSiJi')" width="120">
            <template slot-scope="scope">
              <span>{{scope.row.ISDRIVER|IsDriver}}{{scope.row.GD1|IsExternalDriver}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('message.tempeoraryPasswordTitle')" prop="password"></el-table-column> -->
          <!-- <el-table-column :label="$t('message.attendanceNumTitle')" prop="GD4" width="140"></el-table-column>
          <el-table-column :label="$t('message.driverArea')" prop="ADDRESS" width="140"></el-table-column>
          <el-table-column :label="$t('message.attendanceHoursTitle')" prop="GD5" width="140"></el-table-column>-->
          <el-table-column :label="$t('message.clockInDetailTitle')" min-width="100" fixed="right">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button
                  class="operation_btn"
                  type="text"
                  @click.native.prevent="checkDetail(scope.row)"
                >{{$t('message.customTableContent')}}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="150" fixed="right">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button
                  class="operation_btn updateBtn"
                  type="text"
                  size="small"
                  @click.native.prevent="updateTempeorary(scope.row)"
                ></el-button>
                <el-button
                  class="operation_btn delBtn"
                  type="text"
                  size="small"
                  @click.native.prevent="delTempeorary(scope.row.ID)"
                ></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage"
      ></el-pagination>
    </div>
    <!-- 添加修改正式员工 -->
    <el-dialog
      :title="maskBoxTitle"
      :visible.sync="showMaskBox"
      width="60%"
      :close-on-click-modal="false"
      center
    >
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryNameTitle')}}</span>
            <el-input
              class="dialog_item_ipnut"
              :placeholder="$t('message.placeholder')"
              v-model="tempeoraryName"
            ></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryPhoneTitle')}}</span>
            <el-input
              class="dialog_item_ipnut"
              :placeholder="$t('message.placeholder')"
              v-model="tempeoraryPhone"
            ></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryAccountTitle')}}</span>
            <el-input
              class="dialog_item_ipnut"
              :placeholder="$t('message.placeholder')"
              v-model="tempeoraryAccount"
            ></el-input>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryPasswordTitle')}}</span>
            <el-input
              class="dialog_item_ipnut"
              :placeholder="$t('message.placeholder')"
              v-model="tempeoraryPassword"
            ></el-input>
          </div>
        </div>

        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.signatureStateTitle')}}</span>
            <el-select v-model="STATE" style="margin-right: 10px;">
              <el-option :label="$t('message.isJob')" value="在职"></el-option>
              <el-option :label="$t('message.isQuit')" value="离职"></el-option>
            </el-select>
          </div>

          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.EmployeeNo')}}</span>
            <el-input
              class="dialog_item_ipnut"
              :placeholder="$t('message.placeholder')"
              v-model="WORKERNO"
            ></el-input>
          </div>
        </div>

        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.BusinessOffice')}}</span>
            <el-select v-model="YINGYESUO" style="margin-right: 10px;">
              <el-option label="大阪営業所" value="大阪営業所"></el-option>
              <el-option label="りんくう営業所" value="りんくう営業所"></el-option>
              <el-option label="東京営業所" value="東京営業所"></el-option>
              <el-option label="関空営業所" value="関空営業所"></el-option>
              <el-option label="泉佐野営業所" value="泉佐野営業所"></el-option>
              <el-option label="市川営業所" value="市川営業所"></el-option>
              <el-option label="大田営業所" value="大田営業所"></el-option>
              <el-option label="藤井寺営業所" value="藤井寺営業所"></el-option>
              <el-option label="成田営業所" value="成田営業所"></el-option>
            </el-select>
          </div>
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.tempeoraryEmailTitle')}}</span>
            <el-input
              class="dialog_item_ipnut"
              :placeholder="$t('message.placeholder')"
              v-model="tempeoraryEmail"
            ></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.IsSiJi')}}</span>
            <el-switch v-model="tempeoraryISDRIVER" active-value="1" inactive-value="0"></el-switch>
            <el-select
              v-if="tempeoraryISDRIVER==='1'"
              v-model="driverLocation"
              style="margin-right: 10px;"
            >
              <el-option label="東京" value="東京"></el-option>
              <el-option label="大阪" value="大阪"></el-option>
            </el-select>
            <span v-if="tempeoraryISDRIVER==='1'" class="dialog_item_title">
              {{$t('message.IsExternalSiJi')}}
              <el-switch v-model="tempeoraryGD1" active-value="1" inactive-value="0"></el-switch>
            </span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showMaskBox = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="addNewTempeoraryMan">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getformalList,
  setformalMan,
  delformalMan,
  getTodayFormal,
  HTTPS,
  exportMoreFormal,
} from '@/api/getData.js'
export default {
  name: 'formalWorkersManage',
  data() {
    return {
      tempeoraryManName: '',
      ISExternalDRIVER: '',
      STATE1: ' ',
      ISDRIVER: '0',
      YINGYESUO1: '',
      attendanceTime: null,
      todayFormal: 0,
      loading: false,
      tempeoraryMenList: [],
      page_no: 1,
      page_size: 10,
      pageSizes: [10, 20, 30, 50, 100],
      totalSize: 0,
      showMaskBox: false,
      maskBoxTitle: '',
      newId: 0,
      tempeoraryName: '',
      tempeoraryPhone: '',
      tempeoraryEmail: '',
      tempeoraryISDRIVER: '',
      tempeoraryGD1: '0',
      driverLocation: '',
      tempeoraryAccount: '',
      tempeoraryPassword: '',
      WORKERNO: '',
      STATE: '',
      YINGYESUO: '',
    }
  },
  created() {
    let param = this.$store.state.JHSS_formalManage_param
    if (param.PAGE) this.page_no = param.PAGE
    if (param.TYPE) this.page_size = param.TYPE
    if (param.USHOWNAME) this.tempeoraryManName = param.USHOWNAME
    if (param.GD1) this.ISExternalDRIVER = param.GD1
    if (param.UADDTIME && param.DADDTIME)
      this.attendanceTime = [param.UADDTIME, param.DADDTIME]
    this.getformalList(param)
    this.getTodayFormal()
  },
  methods: {
    // 查询正式员工列表
    async getformalList(param) {
      this.loading = true
      param = param || {}
      param.PAGE = this.page_no
      param.TYPE = this.page_size
      let res = await getformalList(param)
      this.loading = false
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
        return
      }
      // console.log(res.data)
      this.totalSize = res.data.num
      let _this = this
      let index = (this.page_no - 1) * this.page_size
      this.tempeoraryMenList = res.data.dt.map((item) => {
        item.index = ++index
        item.password = '******'
        return item
      })
      this.$store.commit('setformalManageParam', param)
    },

    // 搜索正式员工姓名
    searchTempeoraryName() {
      this.searchFun()
    },
    // 申请条数
    sizeChange(val) {
      this.page_size = val
      this.searchFun()
    },
    // 当前页
    currentChange(val) {
      this.searchFun(val)
    },
    searchFun(val) {
      this.page_no = val || 1
      let param = {}
      if (this.tempeoraryManName) param.USHOWNAME = this.tempeoraryManName
      if (this.attendanceTime) {
        param.UADDTIME = this.attendanceTime[0]
        param.DADDTIME = this.attendanceTime[1]
      }
      if (this.ISExternalDRIVER) {
        param.GD1 = this.ISExternalDRIVER
      }
      if (this.STATE1) {
        param.STATE = this.STATE1
      }
      if (this.ISDRIVER) {
        param.ISDRIVER = this.ISDRIVER
      }
      if (this.YINGYESUO1) {
        param.YINGYESUO = this.YINGYESUO1
      }
      this.getformalList(param)
    },
    // 添加新的正式员工
    addNewTempeorary() {
      this.maskBoxTitle = this.$t('message.addformalWorkersTitle')
      this.showMaskBox = true
      this.newId = 0
      this.tempeoraryName = ''
      this.tempeoraryPhone = ''
      this.tempeoraryEmail = ''
      this.tempeoraryISDRIVER = ''
      this.tempeoraryGD1 = '0'
      this.driverLocation = ''
      this.tempeoraryAccount = ''
      this.tempeoraryPassword = ''
      this.WORKERNO = ''
      this.STATE = ''
      this.YINGYESUO = ''
    },
    // 更新正式员工
    updateTempeorary(obj) {
      this.maskBoxTitle = this.$t('message.updateformalWorkersTitle')
      this.showMaskBox = true
      this.newId = obj.ID
      this.tempeoraryName = obj.USHOWNAME
      this.tempeoraryPhone = obj.TELPHONE
      this.tempeoraryEmail = obj.EMAIL
      this.tempeoraryAccount = obj.UINPUTNAME
      this.WORKERNO = obj.WORKERNO
      this.STATE = obj.STATE
      this.YINGYESUO = obj.YINGYESUO
      this.tempeoraryPassword = obj.PASSWORD
      this.tempeoraryISDRIVER = obj.ISDRIVER
      this.tempeoraryGD1 = obj.GD1
      this.driverLocation = obj.ADDRESS
      console.log(obj)
    },
    async addNewTempeoraryMan() {
      if (!this.tempeoraryName) {
        this.$message.error(this.$t('message.tempeoraryNameTitle'))
      } else if (!this.tempeoraryPhone) {
        this.$message.error(this.$t('message.tempeoraryPhoneTitle'))
      } else if (!this.tempeoraryAccount) {
        this.$message.error(this.$t('message.tempeoraryAccountTitle'))
      } else if (!this.tempeoraryPassword) {
        this.$message.error(this.$t('message.tempeoraryPasswordTitle'))
      } else if (!this.WORKERNO) {
        this.$message.error(this.$t('message.EmployeeNo'))
      } else if (!this.STATE) {
        this.$message.error(this.$t('message.signatureStateTitle'))
      } else if (!this.YINGYESUO) {
        this.$message.error(this.$t('message.BusinessOffice'))
      } else {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        let param = {
          ID: this.newId,
          UINPUTNAME: this.tempeoraryAccount,
          WORKERNO: this.WORKERNO,
          STATE: this.STATE,
          YINGYESUO: this.YINGYESUO,
          USHOWNAME: this.tempeoraryName,
          PASSWORD: this.tempeoraryPassword,
          TELPHONE: this.tempeoraryPhone,
          EMAIL: this.tempeoraryEmail,
          ISDRIVER: this.tempeoraryISDRIVER,
          GD1: this.tempeoraryGD1,
          ADDRESS: this.driverLocation,
        }
        console.log('param', param)
        let res = await setformalMan(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.showMaskBox = false
          this.getformalList()
        }
      }
    },
    // 删除正式员工
    delTempeorary(id) {
      this.$confirm(
        this.$t('message.delTempeoraryPeompt'),
        this.$t('message.promptTitle'),
        {
          closeOnClickModal: false,
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText'),
        }
      )
        .then(() => {
          this.del(id)
        })
        .catch(() => {
          this.$message(this.$t('message.canclePrompt'))
        })
    },
    async del(id) {
      let param = { ID: id }
      let res = await delformalMan(param)
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
        return
      }
      if (res.data.result !== '1') {
        this.$message.error(res.data.message)
      } else {
        // this.page_no = 1
        // this.getformalList()
        this.searchTempeoraryName()
      }
    },
    // 查看打卡明细
    checkDetail(obj) {
      console.log('aaaaaaa', obj)
      this.$router.push({
        path: '/formalWorkersClockStatistics',
        query: {
          formalInfo: JSON.stringify(obj),
          attendanceTime: JSON.stringify(this.attendanceTime),
        },
      })
    },
    async getTodayFormal() {
      let res = await getTodayFormal({})
      this.todayFormal = res.data.result
    },
    // 导出多个临时员工工资表
    async exportMoreFormal() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let param = this.$store.state.JHSS_formalManage_param
      let res = await exportMoreFormal(param)
      loading.close()
      if (res.status !== 200) {
        this.$message.error('network error：' + res.status)
      } else {
        // console.log(res.data)
        let str = HTTPS + '/xlsx/' + res.data
        window.open(str)
      }
    },
  },
  filters: {
    // STATE(value) {
    //   if (value === '离职') {
    //     return `${$t('message.isQuit')}`
    //   } else {
    //     return `${$t('message.isJob')}`
    //   }
    // },
    IsDriver(value) {
      if (value === '1') {
        return '是'
      } else {
        return '否'
      }
    },
    IsExternalDriver(value) {
      if (value === '1') {
        return '(外部司机)'
      } else {
        return ''
      }
    },
  },
}
</script>

<style scoped>
</style>
